import { useApplicationStore } from 'modules/application/store';

interface MobileDesktopSwitcherProps {
  Mobile: React.ElementType;
  Desktop: React.ElementType;
}

const MobileDesktopSwitcher = ({ Mobile, Desktop }: MobileDesktopSwitcherProps) => {
  const isMobile = useApplicationStore((state) => state.isMobile);

  if (isMobile) {
    return <Mobile />;
  }

  return <Desktop />;
};

export default MobileDesktopSwitcher;
